import { render, staticRenderFns } from "./LanguagePicker.vue?vue&type=template&id=1a60d855&scoped=true"
import script from "./LanguagePicker.vue?vue&type=script&setup=true&lang=js"
export * from "./LanguagePicker.vue?vue&type=script&setup=true&lang=js"
import style0 from "./LanguagePicker.vue?vue&type=style&index=0&id=1a60d855&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a60d855",
  null
  
)

export default component.exports